import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { wishlistExport } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/actionCreators';
import { wishlistPrint } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistPrint/actionCreators';
import {
  clearWishlistSend,
  wishlistSend,
} from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistSend/actionCreators';
import { SendToSalesDataType } from 'b2b-common/core/account/api/wishlists';

type WishlistExportActionType = (
  wishlistId: string,
  fileName: string,
  fileType?: string,
) => void;

type WishlistPrintActionType = (
  content: string,
  wishlistId: string,
) => void;

type WishlistSendActionType = (
  wishlistId: string,
  data: SendToSalesDataType,
) => void;

type WishlistClearSendActionType = () => void;

type UseWishlistActionsReturnType = {
  export: WishlistExportActionType;
  print: WishlistPrintActionType;
  send: WishlistSendActionType;
  clearSend: WishlistClearSendActionType;
};

const useWishlistActions = (): UseWishlistActionsReturnType => {
  const dispatch = useDispatch();
  return {
    export: useMemo(() => bindActionCreators(wishlistExport, dispatch), [
      dispatch,
    ]),
    print: useMemo(() => bindActionCreators(wishlistPrint, dispatch), [
      dispatch,
    ]),
    send: useMemo(() => bindActionCreators(wishlistSend, dispatch), [dispatch]),
    clearSend: useMemo(() => bindActionCreators(clearWishlistSend, dispatch), [
      dispatch,
    ]),
  };
};

export type {
  UseWishlistActionsReturnType,
  WishlistClearSendActionType,
  WishlistExportActionType,
  WishlistPrintActionType,
  WishlistSendActionType,
};

export { useWishlistActions };
